import { gql } from "apollo-boost";

export const INVOICE_NOTE_CREDIT_MUTATION = gql`
  mutation saveConsultoryCreditNote($data: ConsultoryCreditNoteInput) {
    saveConsultoryCreditNote(data: $data) {
      id
      monthlyClosingId
      arsId
      insurerName
      insurerRnc
      voucherName
      voucherDueDate
      ncf
      applyNcf
      date
      amount
      itbis
      total
      concept
    }
  }
`;
